<template>
  <co-button
    :disabled="disabled"
    :self-class="disabled?'s-btn-disabled':'s-btn'"
    @click="clickBtn"
  >
    <slot />
  </co-button>
</template>
<script>
import coButton from 'components/common/button/index.vue'

export default {
  components: {
    coButton,
  },
  props: {
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    clickBtn() {
      if (!this.disabled) {
        this.$emit('click')
      }
    },
  },
}
</script>
